import React from "react";
import LoginForm from "../Components/Forms/LoginForm";

const Login = () => {
  return <LoginForm />;
};

export default Login;
